<template>
  <transition name="modal-animation">
    <div v-show="modalActive" class="modal">
      <transition name="modal-animation-inner">
        <div v-show="modalActive" class="modal-inner">
          <slot />
          <Button label="Close" class="qb-btn qb-btn-outline-md ms-2" @onClick="close" />
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
import Button from "./ButtonComponent.vue";
export default {
  name: "ModalComponent",
  props: {
    modalActive: {
      type: Boolean,
    },
  },
  components: {
    Button,
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/color.scss";
@import "../assets/scss/font.scss";
@import "../assets/scss/field.scss";

.modal-animation-enter-active,
.modal-animation-leave-active {
  transition: opacity 0.3s cubic-bezier(0.52, 0.02, 0.19, 1.02);
}
.modal-animation-enter-from,
.modal-animation-leave-to {
  opacity: 0;
}
.modal-animation-inner-enter-active {
  transition: all 0.3s cubic-bezier(0.52, 0.02, 0.19, 1.02) 0.15s;
}
.modal-animation-inner-leave-active {
  transition: all 0.3s cubic-bezier(0.52, 0.02, 0.19, 1.02);
}
.modal-animation-inner-enter-from {
  opacity: 0;
  transform: scale(0.8);
}
.modal-animation-inner-leave-to {
  transform: scale(0.8);
}

.modal {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(9, 30, 66, 0.54);
  .modal-inner {
    position: relative;
    max-width: 550px;
    margin-top: 70px;
    margin-bottom: 100px;
    width: 80%;
    background-color: #fff;
    border-radius: $field-border-radius;
    padding: 30px;
  }
}
</style>
